import { css } from "@emotion/core";
import { fontSizes, fontTypes, fontWeight } from "../../constants/commons";

export const otpInputFieldStyle = css`
  min-height: 20em;

  .otp-style {
    border-left: none;
    border-right: none;
    border-top: none;
    width: 3rem !important;
    height: 3rem;
    margin: 0 0.2rem;
    font-size: ${fontSizes.lg};
  }
  .container-otp {
    justify-content: center !important;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .heading-style {
      font-size: ${fontSizes.xlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    .responsive-width {
      width: 65%;
    }
    .clear-all-style {
      display: flex;
      justify-content: flex-end;
      right: 0;
      position: absolute;
      bottom: 55%;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .heading-style {
      font-size: ${fontSizes.xlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    .responsive-width {
      width: 65%;
    }
    .clear-all-style {
      display: flex;
      justify-content: flex-end;
      right: 0;
      position: absolute;
      bottom: 55%;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .heading-style {
      font-size: ${fontSizes.xlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    .responsive-fixed-bottom {
      position: absolute;
      bottom: -3%;
      width: 35%;
      left: 33%;
    }
    .responsive-width {
      width: 67%;
    }
    .clear-all-style {
      display: flex;
      justify-content: flex-end;
      right: 5%;
      position: absolute;
      bottom: 48%;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .heading-style {
      font-size: ${fontSizes.xxlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    .responsive-fixed-bottom {
      position: absolute;
      bottom: -3%;
      width: 35%;
      left: 33%;
    }
    .responsive-width {
      width: 83%;
    }
    .clear-all-style {
      display: flex;
      justify-content: flex-end;
      right: 5%;
      position: absolute;
      bottom: 48%;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .heading-style {
      font-size: ${fontSizes.xxlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    .responsive-fixed-bottom {
      position: absolute;
      bottom: 8%;
      width: 35%;
      left: 33%;
    }
    .responsive-width {
      width: 75%;
    }
    .clear-all-style {
      display: flex;
      justify-content: flex-end;
      right: 5%;
      position: absolute;
      bottom: 48%;
    }
  }
`;
